import React, {useContext} from "react";
import { I18n } from "aws-amplify/utils";
import {Image} from "primereact/image";
import {isFormateur} from "../Utils";
import {UserContext} from "../app-context";

const Home = (props) => {
    const authenticatedUserData = useContext(UserContext);

    // authenticatedUserData starts as {} while the profile fetch (App.js's refreshAuthenticationData)
    // is still in flight. userType can't be the "loaded" signal: a candidat never has a userType
    // attribute at all (see isFormateur/find-users-without-parcours.mjs - absent userType IS a
    // candidat, not "unknown yet"), so gating on it left candidats stuck on this spinner forever.
    // username is always set by completeMyProfile once the fetch resolves (same signal used by
    // FormateurDeclarationsFrais/SaisiePresence/FormateurSchedule), so use that instead.
    if (!authenticatedUserData || !authenticatedUserData.username) {
        return (
            <div role="status" aria-live="polite" style={{textAlign: 'center', padding: '3rem'}}>
                <i className="fcdm fcdm-m" aria-hidden="true" style={{fontSize: '3rem'}}/>
                <span className="sr-only">{I18n.get("loading")}</span>
            </div>
        );
    }

    if (isFormateur(authenticatedUserData)) {
        return (
            <div className="grid">
                <div className="col-12">
                    <div className="card">
                        <h1 style={{ color: "#1b7a94", fontWeight: "bolder" }}>{I18n.get("accueil.formateurTitle")}</h1>
                        <h2 style={{ color: "#1b7a94", fontWeight: "bolder" }}>{I18n.get("accueil.formateurSubTitle1")}</h2>
                        <p dangerouslySetInnerHTML={{__html: I18n.get("accueil.formateurP1")}}></p>
                        <h2 style={{ color: "#1b7a94", fontWeight: "bolder" }}>{I18n.get("accueil.formateurSubTitle2")}</h2>
                        <p dangerouslySetInnerHTML={{__html: I18n.get("accueil.formateurP2")}}></p>
                        <p dangerouslySetInnerHTML={{__html: I18n.get("accueil.formateurP3")}}></p>
                        <p dangerouslySetInnerHTML={{__html: I18n.get("accueil.formateurP4")}}></p>
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div className="grid">
                <div className="col-12">
                    <div className="card">
                        <h1 style={{ color: "#1b7a94", fontWeight: "bolder" }}>{I18n.get("accueil.title")}</h1>
                        <h2 style={{ color: "#1b7a94", fontWeight: "bolder" }}>{I18n.get("accueil.subTitle1")}</h2>
                        <p dangerouslySetInnerHTML={{__html: I18n.get("accueil.p1")}}></p>
                        <h2 style={{ color: "#1b7a94", fontWeight: "bolder" }}>{I18n.get("accueil.subTitle2")}</h2>
                        <p dangerouslySetInnerHTML={{__html: I18n.get("accueil.p2")}}></p>
                        <h2 style={{ color: "#1b7a94", fontWeight: "bolder" }}>{I18n.get("accueil.subTitle3")}</h2>
                        <p dangerouslySetInnerHTML={{__html: I18n.get("accueil.p3")}}></p>
                        <Image src={`assets/layout/images/parcours_${I18n.get("language")}${authenticatedUserData && ("15000 23000 25000 26000 29000 33000 34000 43000 44000 45000 46000 47000".includes(authenticatedUserData.codeMetier) ? authenticatedUserData.codeMetier : "")}.png`}
                               alt={I18n.get("accueil.parcoursimagealt")} width="700" preview />
                        <h2 style={{ color: "#1b7a94", fontWeight: "bolder" }}>{I18n.get("accueil.subTitle4")}</h2>
                        <p dangerouslySetInnerHTML={{__html: I18n.get("accueil.p4")}}></p>
                    </div>
                </div>
            </div>
        );
    }

}
export default React.memo(Home);
